export const uk = {
    adaptive: 'Адаптивный креатив',
    'adaptive-disclaimer':
        'Идея нового адаптивного объявления, которое автоматически подстраивается под нужный рекламный блок на площадке.',
    'adaptive-info':
        'Ваше изображение для креатива должно соответствовать следующим техническим требованиям: максимальное разрешение не более 1500х800 пикселей (изображения большего размера будут сжаты), размер изображения после сжатия не должен превышать 512 кБ.',
    'apply-adaptive': 'Попробовать!',
    'create-banners': 'Створити',
    'empty-message':
        'Тут поки що немає ідей креативів. Зазначте URL-адресу сторінки сайту, і конструктор згенерує ідеї креативів на основі її вмісту.',
    'progress-message': 'Завантажуємо вміст сторінки',
    'progress-message1': 'Продовжуємо завантаження вмісту сторінки',
    'progress-message2':
        'Продовжуємо завантаження вмісту сторінки. Можливо, створюється багато ідей або сайт відповідає повільно',
    'url-placeholder': 'URL сторінки вашого сайту'
};
